import { render, staticRenderFns } from "./PostTable.vue?vue&type=template&id=31ec316e&scoped=true&"
import script from "./PostTable.vue?vue&type=script&lang=js&"
export * from "./PostTable.vue?vue&type=script&lang=js&"
import style0 from "./PostTable.vue?vue&type=style&index=0&id=31ec316e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec316e",
  null
  
)

export default component.exports